<template>
<div ref="quickpass-slide" class="quickpass-slide">
    <swiper :options="swiperOption" ref="mySwiper">
        <!-- slides -->
        <swiper-slide class="qs qs-1">
            <h2>付款码支付</h2>
            <p>1.进入闪付页面，打开【付款】，出示给商户扫描即可完成交易。</p>
            <p>2.超过免密限额的订单需验证支付密码。</p>
            <p>3.付款码每分钟会自动更新，并会在生成之后短时间内有效，请勿泄露任何有关付款码的信息。</p>
            <div class="phone-bg">
                <div class="pb-left">
                    <div class="pb-pic"></div>
                    <p><i>1</i>打开付款</p>
                </div>
                <div class="pb-right">
                    <div class="pb-pic"></div>
                    <p><i>2</i>出示付款码给收银员</p>
                </div>
                <div class="triangle-right">
                    <div class="react"></div>
                    <div class="t-r"></div>
                </div>
            </div>
            <div class="yun-1"></div>
            <div class="yun-2"></div>
            <div class="arrow-bottom animation_arr_bottom"></div>
        </swiper-slide>

        <swiper-slide class="qs qs-2">
            <h2>付款码支付</h2>
            <p>1.进入闪付页面，打开【付款】，出示给商户扫描即可完成交易。</p>
            <div class="phone-bg">
                <div class="pb-left">
                    <div class="pb-pic"></div>
                    <p><i>1</i>打开扫一扫</p>
                </div>
                <div class="pb-right">
                    <div class="pb-pic"></div>
                    <p><i>2</i>扫描商户收银码</p>
                </div>
                <div class="triangle-right">
                    <div class="react"></div>
                    <div class="t-r"></div>
                </div>
            </div>
            <div class="yun-1"></div>
            <div class="yun-2"></div>
            <div class="arrow-bottom animation_arr_bottom"></div>
        </swiper-slide>

        <swiper-slide class="qs qs-3">
            <h2>付款码支付</h2>
            <p>1、以下商家均可使用点点闪付进行线下支付。</p>
            <p>2、请在标记有银联闪付的商户使用。<b class="b1"></b><b class="b2"></b></p>
            <ul>
                <li>
                    <div class="sj-box">
                        <div class="sj-icon"></div>
                        <p>家乐福</p>
                    </div>
                    <div class="sj-box">
                        <div class="sj-icon"></div>
                        <p>全家</p>
                    </div>
                    <div class="sj-box">
                        <div class="sj-icon"></div>
                        <p>罗森</p>
                    </div>
                </li>
                <li>
                    <div class="sj-box">
                        <div class="sj-icon"></div>
                        <p>屈臣氏</p>
                    </div>
                    <div class="sj-box">
                        <div class="sj-icon"></div>
                        <p>711</p>
                    </div>
                    <div class="sj-box">
                        <div class="sj-icon"></div>
                        <p>万宁</p>
                    </div>
                </li>
                <li>
                    <div class="sj-box">
                        <div class="sj-icon"></div>
                        <p>汉堡王</p>
                    </div>
                    <div class="sj-box">
                        <div class="sj-icon"></div>
                        <p>正大广场</p>
                    </div>
                    <div class="sj-box">
                        <div class="sj-icon"></div>
                        <p>大润发</p>
                    </div>
                </li>
            </ul>
        </swiper-slide>
        <!-- Optional controls -->
        <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
</div>
</template>

<script>
import storage from '../utils/storage'
import {
    api
} from '../api/axios';
import {
    swiper,
    swiperSlide
} from 'vue-awesome-swiper'
export default {
    data() {
        var _vue = this
        return {
            sjList: [{},{},{}],
            swiperOption: {
                // some swiper options/callbacks
                // 所有的参数同 swiper 官方 api 参数
                direction: 'vertical',
                // effect : 'fade',
                // autoHeight: true,
                height: 600,
                speed:400
                // passiveListeners : false
                // on: {
                //     touchEnd: function(event) {
                //         //你的事件
                //         // console.log(_vue.text);
                //     },
                //     reachEnd: function() {
                //         // alert('到了最后一个slide');
                //     },
                // },
            }
        }
    },
    components: {
        swiper,
        swiperSlide
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.swiper
        }
    },
    beforeRouteEnter(to, from, next) {
        document.title = '闪付教程'
        next()
    },
    created() {
        this.swiperOption.height = document.documentElement.clientHeight || document.body.height
    },
    mounted() {
        console.log('this is current swiper instance object', this.swiper)
        // this.swiper.slideTo(3, 1000, false)
        // console.log(this.swiperOption.on.touchEnd,'eeee');
    },
    methods: {
        nextRoute(index) {
            window._helpItemIndex = index
        }

    }
}
</script>



// WEBPACK FOOTER //
// quickpass.vue?7b89ce8b